import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { datadogRum } from "@datadog/browser-rum";
import { userManager } from "../../../auth/oidcConfig";

export default function AuthCallback() {
  const navigate = useNavigate();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    userManager
      .signinRedirectCallback()
      .then(() => {
        const urlBeforeLogin =
          localStorage.getItem("post_login_redirect") || "/";
        navigate(urlBeforeLogin, { replace: true });
      })
      .catch(async (err) => {
        datadogRum.addError(err);
        await userManager.removeUser();
        await userManager.clearStaleState();
        navigate("/signed-out", { replace: true });
      });
  }, [navigate]);

  return <div>Logging in...</div>;
}
